import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import makeStyles from '@mui/styles/makeStyles';

var useStyles = makeStyles(function () {
  return {
    container: {
      display: 'block',
      textAlign: 'center'
    },
    logo: {
      maxWidth: '100%',
      imageRendering: 'crisp-edges'
    },
    // https://caniuse.com/mdn-css_properties_image-rendering_crisp-edges
    alternativeBrowserLogo: {
      imageRendering: '-webkit-optimize-contrast'
    }
  };
});

var Logo = function Logo(_ref) {
  var logo = _ref.logo,
      _ref$maxHeight = _ref.maxHeight,
      maxHeight = _ref$maxHeight === undefined ? 150 : _ref$maxHeight,
      children = _ref.children;

  var classes = useStyles();
  return React.createElement(
    'div',
    { className: classes.container },
    React.createElement('img', {
      className: cx(classes.logo, classes.alternativeBrowserLogo),
      style: { maxHeight: maxHeight },
      src: logo,
      alt: 'logo'
    }),
    children
  );
};

Logo.propTypes = process.env.NODE_ENV !== "production" ? {
  logo: PropTypes.string,
  maxHeight: PropTypes.number,
  children: PropTypes.object
} : {};

export default Logo;